export default __webpack_public_path__ + "static/media/Giuria e Brugnolo.25419226.jpg";